<template>
  <div class="details-component">
    <div class="details-component__header">
      <h1>{{ $t('nav.users') }}</h1>
      <div class="details-component__header_right">

        <a class="link" v-on:click="openAddNew">
          {{ $t('users.add_user') }}
          <i class="icon icon--plus"></i>
        </a>
      </div>
    </div>

    <div class="details-component__add-new-form"
         v-if="isPasswordSetFormOpened"
         v-bind:class="{ active: isPasswordSetFormOpened }">
      <form class="form">
        <div class="form__field" :class="{'form__field_error' : errors.has('password')}">
          <label for="password" class="form__label">{{ $t('login.new_password') }}</label>
          <input
            id="password"
            type="password"
            class="form__credentials-input"
            v-model="form.password"
            :placeholder="$t('login.new_password')"
            name="password"
            v-validate="'required|min:6'"
            data-vv-validate-on="blur"
          />
        </div>

        <div class="form__buttons buttonset">
          <button
            type="submit"
            class="buttonset__button btn btn--main"
            v-on:click.prevent.stop="resetPassword()">
            {{ $t('common.save') }}
          </button>
        </div>
      </form>
    </div>

    <div class="details-component__content content" v-if="users">
      <v-client-table :data="users" :columns="columns" :options="options"></v-client-table>
    </div>

    <WarningModal v-if="showWarningModal" @close="closeWarningModal">
      <h1 slot="header">{{ warningHeader }}</h1>
      <p slot="body">{{ warningBody }}</p>
    </WarningModal>

  </div>
</template>

<script>
  import WarningModal from 'common/WarningModal';
  import { mapGetters } from 'vuex';
  import moment from 'moment';
  import { format } from 'libphonenumber-js';
  import * as mTypes from 'store/mutation-types';

  export default {
    components: {
      WarningModal,
    },
    props: ['users', 'tenant'],
    computed: mapGetters({
      userError: `users/user/${mTypes.DATA_ERROR}`,
    }),
    methods: {
      formatDate(value) {
        if (!value) {
          return moment().format('DD.MM.YYYY');
        }
        return value;
      },
      formatMobileNr(value, mobileCountry) {
        if (value && typeof value !== 'undefined') {
          return format({ country: mobileCountry, phone: value.toString() }, 'International_plaintext');
        }
        return value;
      },
      openAddNew() {
        const query = { tenant: this.tenant.id };
        if (this.isSuperAdmin()) {
          query.landlord = this.tenant.landlord.id;
        }
        this.$router.push({ name: 'add-user', query });
      },
      openUserData(row) {
        this.$router.push({ name: 'user', params: { id: row.id } });
      },
      openPasswordSetForm(row) {
        this.form = {
          userId: row.id,
        };
        this.isPasswordSetFormOpened = true;
      },
      resetPassword() {
        this.$validator.validateAll()
          .then((success) => {
            if (!success) {
              return;
            }
            this.form.partner_id = this.$route.params.id;
            this.$store.dispatch('users/user/setPassword', { userId: this.form.userId, data: this.form, user: this.user }).then(() => {
              if (this.userError) {
                this.warningHeader = this.$t('accounts.set_password_error_header');
                this.warningBody = this.$t('accounts.set_password_error');
                this.showWarningModal = true;
              }
              this.isPasswordSetFormOpened = false;
            }).catch(() => {
              this.warningHeader = this.$t('accounts.set_password_error_header');
              this.warningBody = this.$t('accounts.set_password_error');
              this.showWarningModal = true;
            });
          });
      },
      closeWarningModal() {
        this.showWarningModal = false;
        this.$store.commit(`users/user/${mTypes.DATA_ERROR}`, null);
      },
    },
    data() {
      return {
        form: {},
        isPasswordSetFormOpened: false,
        showWarningModal: false,
        warningHeader: null,
        warningBody: null,
        columns: ['name', 'email', 'mobile', 'createdAt', 'set_password'],
        options: {
          filterable: false,
          rowClassCallback: () => 'VueTables__row',
          headings: {
            name: () => this.$t('common.name'),
            email: () => this.$t('common.email'),
            mobile: () => this.$t('common.phone'),
            createdAt: () => this.$t('common.created_at'),
            set_password: () => '',
          },
          texts: {
            noResults: this.$t('tables.noRecords'),
            count: this.$t('tables.count'),
          },
          templates: {
            name: (h, row) => (
              <span>
                <a on-click={ () => this.openUserData(row) } class="link">
                  {row.name}
                </a>
              </span>
            ),
            email: (h, row) => (
              <span>{row.email}</span>
            ),
            mobile: (h, row) => (
              this.formatMobileNr(row.mobile, row.mobileCountry)
            ),
            createdAt: (h, row) => (
              this.formatDate(row.createdAt)
            ),
            set_password: (h, row) => (
              <div class="delete-wrapper">
                <a on-click={ () => this.openPasswordSetForm(row) }>
                  { this.$t('login.set_new_password') }
                </a>
              </div>
            ),
          },
        },
      };
    },
  };
</script>
<style lang="scss" scoped>
  @import '~styles/blocks/details.scss';
  .details-component__listWidget {
    width: 50%;
  }
</style>



// WEBPACK FOOTER //
// src/components/tenants/UsersTable.vue